import React, { useContext } from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { contactInfo } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Contact() {
  const { isDark } = useContext(StyleContext);

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main">
          <div className="contact-header">
            <h1 className="heading contact-title">{contactInfo.title}</h1>

            {/* Render status as one or more lines */}
            {contactInfo.status && (
              Array.isArray(contactInfo.status) ? (
                contactInfo.status.map((line, index) => (
                  <p
                    key={index}
                    className={
                      isDark
                        ? "dark-mode contact-subtitle"
                        : "subTitle contact-subtitle"
                    }
                  >
                    {line}
                  </p>
                ))
              ) : (
                <p
                  className={
                    isDark
                      ? "dark-mode contact-subtitle"
                      : "subTitle contact-subtitle"
                  }
                >
                  {contactInfo.status}
                </p>
              )
            )}

            <p
              className={
                isDark
                  ? "dark-mode contact-subtitle"
                  : "subTitle contact-subtitle"
              }
            >
              {contactInfo.subtitle}
            </p>

            <div
              className={
                isDark ? "dark-mode contact-text-div" : "contact-text-div"
              }
            >
              <a
                className="contact-detail-email"
                href={"mailto:" + contactInfo.email_address}
              >
                {contactInfo.email_address}
              </a>
              <br />
              <br />
              {contactInfo.number && (
                <>
                  <a
                    className="contact-detail"
                    href={"tel:" + contactInfo.number}
                  >
                    {contactInfo.number}
                  </a>
                  <br />
                  <br />
                </>
              )}

              <SocialMedia />
            </div>
          </div>

          <div className="contact-image-div">
            <img
              alt="Contact"
              src={require("../../assets/images/my_image.png")}
            />
          </div>
        </div>
      </div>
    </Fade>
  );
}